import React, { useEffect, useState, useRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import { CSVLink } from "react-csv";
import _ from "lodash";
import ReactPaginate from "react-paginate";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ChatGptList(props) {
  // const [formData, setName] = useState({ Chint: "", ApNm: "" });
  const [formData, setName] = useState({
    Chint: "",
    UrNm: "",
    PID: "",
    CaseNm: "",
    CaseResp: "",
  });
  const [QuesList, setQuesList] = useState([]);
  const [QuesList2, setQuesList2] = useState([]);
  //const [EType, setType] = React.useState("");

  const [disable, setDisable] = useState(true);
  const [todate, setTodatePic] = useState("");
  const [fromdate, setFromdatePic] = useState("");
  const [FrDate, setFrDate] = useState("");
  const [ToDate, setToDate] = useState("");
  const [todateformat, setTodateformat] = useState("");
  const [fromdateformat, setFromdateformat] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [paginatedPosts, setpaginatedPosts] = useState();
  const ManagerId = localStorage.getItem("ManegerId");
  const Role = localStorage.getItem("URole");
  let [loading, setLoading] = useState(true);


  const [Record, seRecord] = useState([]);

  const csvLink = useRef();
  let pageSize = 10;

  const navigate = useHistory();

  useEffect(() => {
    LoadGptList();
  }, [pageSize]);

  const LoadGptList = () => {
    setLoading(true);
    const datavalue = {
      ManagerId: Role == "Admin" ? 1 : ManagerId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetScenarioChatQuesListDesc`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };

    axios(authOptions)
      .then((res) => {
        seRecord(res.data.length);
        if (res.data.length > 10) {
          setQuesList(res.data);

          setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
        } else {
          setQuesList2(res.data);
        }
      })
      .finally(() => setLoading(false));
  };
  const pageCount = QuesList ? Math.ceil(QuesList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(QuesList).slice(startIndex).take(pageSize).value();
    setpaginatedPosts(paginatedPost);
  };

  const handlefromdate = (date) => {
    const getfromdatevalue = formatDate(date);

    // setToDate(e.target.value)
    setFromdatePic(date);

    const setfromformat = getfromdatevalue.split("-");
    const setfromyear = setfromformat[0];
    const setfrommonth = setfromformat[1];
    const setfromdate = setfromformat[2];
    const setfromformatdate =
      setfromyear + "" + setfrommonth + "" + setfromdate;
    setFrDate(getfromdatevalue);
    setFromdateformat(setfromformatdate);
    // console.log("click to")
    setDisable(false);
    // //console.log(setfromformatdate);
  };
  const handletodate = (date) => {
    // const gettodatevalue = date;
    // console.log("selected date", date);

    // setFrDate(date);
    const gettodatevalue = formatDate(date);

    console.log("selected date changed", gettodatevalue);
    setTodatePic(date);
    const setdateformat = gettodatevalue.split("-");
    const settoyear = setdateformat[0];
    const settomonth = setdateformat[1];
    const settodate = setdateformat[2];
    const settodateformat = settoyear + "" + settomonth + "" + settodate;
    setToDate(gettodatevalue);
    setTodateformat(settodateformat);
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    let formDataSet = new FormData();

    // console.log("its allow", formData.ApNm)

    //alert("todate "+todate+ "form date"+ fromdate);
    //console.log("the date show", FrDate == null || FrDate == "" ? "ope" : FrDate, ToDate, EType, formData.Chint == null || formData.Chint == "" ? "po" : formData.Chint)

    if (fromdateformat > todateformat) {
      alert("Please select valid date");
    } else {
      // alert("Successfull ! Please set API URL");
      // if (EType != "" || FrDate != "" || ToDate != "" || formData.Chint != "" || formData.ApNm != "") {
      if (
        FrDate != "" ||
        ToDate != "" ||
        formData.Chint != "" ||
        formData.UrNm != "" ||
        formData.PID != "" ||
        formData.CaseNm != "" ||
        formData.CaseResp != ""
      ) {
        formDataSet.append(
          "fdate",
          FrDate == null || FrDate == "" ? "" : FrDate
        );
        formDataSet.append(
          "tdate",
          ToDate == null || ToDate == "" ? "" : ToDate
        );
        formDataSet.append(
          "Chint",
          formData.Chint == null || formData.Chint == "" ? "" : formData.Chint
        );
        formDataSet.append(
          "UsrNm",
          formData.UrNm == null || formData.UrNm == "" ? "" : formData.UrNm
        );
        formDataSet.append(
          "CaseNm",
          formData.CaseNm == null || formData.CaseNm == ""
            ? ""
            : formData.CaseNm
        );
        formDataSet.append(
          "CaseResp",
          formData.CaseResp == null || formData.CaseResp == ""
            ? ""
            : formData.CaseResp
        );
        formDataSet.append(
          "PID",
          formData.PID == null || formData.PID == "" ? "" : Number(formData.PID)
        );
        //formDataSet.append("CSrc", EType == null || EType == "" ? "" : EType);
        formDataSet.append("ManegId", Role == "Admin" ? 1 : ManagerId);

        const config = {
          headers: { "content-type": "multipart/form-data" },
        };

        var authOptions = {
          method: "post",
          url: `${process.env.REACT_APP_API_URL}/GetFilterScenarioChatQues`,
          data: formDataSet,
          headers: { "Content-Type": "multipart/form-data" },
        };

        axios(authOptions)
          .then((res) => {
            //console.log("get value", res.data);

            seRecord(res.data.length);
            if (res.data.length > 10) {
              setQuesList(res.data);
              setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
            } else {
              setQuesList2(res.data);
            }
          })

          .catch((error) => {
            //console.log("error occur", error);
          })
          .finally(() => setLoading(false));
      } else {
        //console.log("comming in else")
        LoadGptList();
      }
    }
  };

  const headers = [
    "Scenario Id",
    "User Name",
    "Character Name",
    "Scenario Name",
    "Question",
    "Response",
    "Expression",
    "Timestamp",
  ];
  const csvData =
    Record > 10
      ? [
        headers,
        ...QuesList.map((item) => {
          let response, emotion;
          try {
            // Escape control characters before parsing JSON
            const escapedJsonString = item.responces.replace(/[\x00-\x1F\x7F-\x9F]/g, function(c) {
              return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
            });
            
            // Parse the JSON string
            const parsedResponses = JSON.parse(escapedJsonString);
            
            // Extract response and emotion
            response = parsedResponses.response;
            emotion = parsedResponses.emotion;
          } catch (error) {
            // Handle parsing errors
            console.error("Error parsing JSON:", error);
            response = null; // or some default value
            emotion = null; // or some default value
          }
          return [
            item.scenario_Id,
            item.user_Name,
            item.character_Name,
            item.scenario_Name,
            item.question,
            response,
            emotion,
            item.timestamp,
          ];
        }),
      ]
      : [
        headers,
        ...QuesList2.map((item) => {
          let response, emotion;
          try {
            // Escape control characters before parsing JSON
            const escapedJsonString = item.responces.replace(/[\x00-\x1F\x7F-\x9F]/g, function(c) {
              return '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
            });
            
            // Parse the JSON string
            const parsedResponses = JSON.parse(escapedJsonString);
            
            // Extract response and emotion
            response = parsedResponses.response;
            emotion = parsedResponses.emotion;
          } catch (error) {
            // Handle parsing errors
            console.error("Error parsing JSON:", error);
            response = null; // or some default value
            emotion = null; // or some default value
          }
          return [
            item.scenario_Id,
            item.user_Name,
            item.character_Name,
            item.scenario_Name,
            item.question,
            response,
            emotion,
            item.timestamp,
          ];
        }),
      ];

  const LoadCsv = () => {
    //console.log("click condition")
  };

  const downloadCsv = (csvData, filename) => {
    const data = encodeURI(
      `data:text/csv;charset=utf-8,${csvData
        .map((row) => row.join(","))
        .join("\n")}`
    );
    const link = document.createElement("a");
    link.setAttribute("href", data);
    link.setAttribute("download", filename);
    link.click();
  };

  // const handleChangeType = (event) => {
  //   setType(event.target.value);
  //   // console.log("selected emo", event.target.value)
  //   if (event.target.value != "") {
  //     // console.log("selected value not", event.target.value)
  //   } else {
  //     window.location.reload(true);
  //   }
  // };

  const handleChange = (e) => {
    setName({ ...formData, [e.target.name]: e.target.value });
  };

  const BackFunc = () => {
    navigate.push("/index");
  };

  return (
    <>
      <div className="page-content-wrapper">
        {loading ? (
          <div className="page-content d-flex justify-content-center align-items-center">
          <div className="my-wrapper">
          <div class="spinner center">
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
            <div class="spinner-blade"></div>
        </div>
          </div>
        
        </div>
        ) : (<></>)
}
        <div className="page-content">
          
          {loading ? (
            <>
            <div className="page-bar" style={{display:"none"}}>
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">List of Questions</div>
              </div>
            </div>

            <div className="page-title-breadcrumb">
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block btn-primary"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row" style={{display:"none"}}>
            <form onSubmit={handleSubmit}>
              <div className="form-group custom-form-padding">
                <div className="row gx-1">
                  <div className="col-lg-12">
                    <div className="form-group row gx-1">

                      <div className="col">
                        <label className="col-12 control-label" htmlFor="question1">Question</label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="Chint"
                          className="form-control"
                          id="question1"
                          placeholder="Enter Question"
                        />
                      </div>

                      <div className="col">
                        <label className="col-12 control-label" htmlFor="userName1">
                          User Name
                        </label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="UrNm"
                          className="form-control"
                          id="userName1"
                          placeholder="Enter User Name"
                        />
                      </div>
                      <div className="col">
                        <label className="col-12 control-label" htmlFor="scenarioName1">
                          Scenario Name
                        </label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="CaseNm"
                          className="form-control"
                          id="scenarioName1"
                          placeholder="Enter Scenario Name"
                        />
                      </div>

                      <div className="col">
                        <label className="col-12 control-label" htmlFor="scenarioId1">Scenario ID</label>
                        <input
                          type="number"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="PID"
                          className="form-control"
                          id="scenarioId1"
                          placeholder="Enter Scenario ID"
                        />
                      </div>
                      <div className="col">
                        <label className="col-12 control-label" htmlFor="response1">Response</label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="CaseResp"
                          className="form-control"
                          id="response1"
                          placeholder="Enter Response"
                        />
                      </div>
                    </div>
                    <div className="row gx-1">
                      <div className="col-md-3 custom-datepicker">
                        <label className="col-12 control-label" htmlFor="fromdate1">
                          {" "}
                          From Date
                        </label>
                        <DatePicker
                          selected={fromdate}
                          onChange={handlefromdate}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="mm/dd/yyyy"
                          className="form-control w-100"
                          name="fromdate"
                          id="fromdate1"
                        />
                      </div>
                      <div className="col-md-3 custom-datepicker">
                        <label className="col-12  control-label" htmlFor="todate">To date</label>
                        <DatePicker
                          selected={todate}
                          onChange={handletodate}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="mm/dd/yyyy"
                          className="form-control w-100"
                          name="todate"
                          disabled={disable}
                          id="todate"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="offset-md-3 col-md-9">
                  <div className="col-12 text-end">
                    <button
                      type="submit"
                      className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 me-2 btn-primary"
                    >
                      Search
                    </button>

                    {/* <button style={{ backgroundColor: '#76B947'}}> */}
                    {/* <button type="button" onClick={handleDownloadCsv} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"> */}
                    <CSVLink
                      data={csvData}
                      className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"
                      filename={"ChatGptFile.csv"}
                      target="_blank"
                      style={{ color: "black" }}
                    >
                      Export
                    </CSVLink>

                    {/* </button> */}
                  </div>
                </div>
              </div>
            </form>
          </div></>
          ) : (
            <>
            <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title my-0">List of Questions</div>
              </div>
            </div>

            <div className="page-title-breadcrumb">
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn d-inline-block btn-primary"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <form onSubmit={handleSubmit}>
              <div className="form-group custom-form-padding">
                <div className="row gx-1">
                  <div className="col-lg-12">
                    <div className="form-group row gx-1">

                      <div className="col">
                        <label className="col-12 control-label" htmlFor="question">Question</label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="Chint"
                          className="form-control"
                          id="question"
                          placeholder="Enter Question"
                        />
                      </div>

                      <div className="col">
                        <label className="col-12 control-label" htmlFor="userName">
                          User Name
                        </label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="UrNm"
                          className="form-control"
                          id="userName"
                          placeholder="Enter User Name"
                        />
                      </div>
                      <div className="col">
                        <label className="col-12 control-label" id="scenarioName">
                          Scenario Name
                        </label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="CaseNm"
                          className="form-control"
                          id="scenarioName"
                          placeholder="Enter Scenario Name"
                        />
                      </div>

                      <div className="col">
                        <label className="col-12 control-label" id="scenarioId">Scenario ID</label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="PID"
                          className="form-control"
                          id="scenarioId"
                          placeholder="Enter Scenario ID"
                        />
                      </div>
                      <div className="col">
                        <label className="col-12 control-label" htmlFor="response">Response</label>
                        <input
                          type="text"
                          // value={formData.pId}
                          onChange={handleChange}
                          name="CaseResp"
                          className="form-control"
                          id="response"
                          placeholder="Enter Response"
                        />
                      </div>
                    </div>
                    <div className="row gx-1">
                      <div className="col-md-3 custom-datepicker">
                        <label className="col-12 control-label" htmlFor="fromdate">
                          {" "}
                          From Date
                        </label>
                        <DatePicker
                        id="fromdate"
                          selected={fromdate}
                          onChange={handlefromdate}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="mm/dd/yyyy"
                          className="form-control w-100"
                          name="fromdate"
                        />
                      </div>
                      <div className="col-md-3 custom-datepicker">
                        <label className="col-12 control-label" htmlFor="todate">To date</label>
                        <DatePicker
                          selected={todate}
                          onChange={handletodate}
                          dateFormat="MM/dd/yyyy"
                          placeholderText="mm/dd/yyyy"
                          className="form-control w-100"
                          name="todate"
                          disabled={disable}
                          id="todate"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="offset-md-3 col-md-9">
                  <div className="col-12 text-end">
                    <button
                      type="submit"
                      className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 me-2 btn-primary"
                    >
                      Search
                    </button>

                    {/* <button style={{ backgroundColor: '#76B947'}}> */}
                    {/* <button type="button" onClick={handleDownloadCsv} className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"> */}
                    <CSVLink
                      data={csvData}
                      className="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-success"
                      filename={"ChatGptFile.csv"}
                      target="_blank"
                      style={{ color: "black" }}
                    >
                      Export
                    </CSVLink>

                    {/* </button> */}
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-head">
                      <header>Question List</header>
                      <div className="tools">
                      </div>
                    </div>
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Scenario ID</th>
                              <th>User Name</th>
                              <th>Character Name</th>
                              <th>Scenario Name</th>
                              <th> Question</th>
                              {/* <th> Intents</th> */}
                              <th style={{ width: "300px" }}>Response</th>
                              <th style={{ width: "150px" }}>Expression</th>
                              {/* <th>Source</th> */}
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Record > 10
                              ? paginatedPosts &&
                                paginatedPosts.length > 0 &&
                                paginatedPosts.map((item) => (
                                  <tr>
                                    <td className="text-left">{item.scenario_Id}</td>
                                    <td className="text-left">
                                      {item.user_Name}
                                    </td>
                                    <td className="text-left">
                                      {item.character_Name}
                                    </td>
                                    <td className="text-left">
                                      {item.scenario_Name}
                                    </td>
                                    <td className="text-left">
                                      {item.question}
                                    </td>
                                    {/* <td className="text-left">{item.intent}</td> */}
                                    <td className="text-left">
                                      {JSON.parse(item.responces).response}
                                    </td>
                                    <td className="text-left">
                                      {JSON.parse(item.responces).emotion}
                                    </td>
                                    {/* <td className="text-left">{item.source}</td> */}
                                    <td className="text-left td-date">
                                      {item.timestamp}
                                    </td>
                                  </tr>
                                ))
                              : QuesList2 &&
                                QuesList2.length > 0 &&
                                QuesList2.map((item) => (
                                  <tr>
                                    <td className="text-left">{item.scenario_Id}</td>
                                    <td className="text-left">
                                      {item.user_Name}
                                    </td>
                                    <td className="text-left">
                                      {item.character_Name}
                                    </td>
                                    <td className="text-left">
                                      {item.scenario_Name}
                                    </td>
                                    <td className="text-left">
                                      {item.question}
                                    </td>
                                    {/* <td className="text-left">{item.intent}</td> */}
                                    <td className="text-left">
                                      {JSON.parse(item.responces).response}
                                    </td>
                                    <td className="text-left">
                                      {JSON.parse(item.responces).emotion}
                                    </td>
                                    {/* <td className="text-left">{item.source}</td> */}
                                    <td className="text-left td-date">
                                      {item.timestamp}
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                      {Record > 10 ? (
                        <ReactPaginate
                          previousLabel={"Prev"}
                          nextLabel={"Next"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={3}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-center"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          activeClassName={"active"}
                          previousClassName={"page-item"}
                          nextClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </>
          )}
        </div>
      </div>
    </>
  );
}

export default ChatGptList;
